export default __webpack_public_path__ + "static/media/live-icon.aa1a12ef.webp";